import { FunctionComponent } from 'react';

// Contexts
import { useAppStore } from '@Components/AppStore/Context';

interface MedicalSpecialtyProps {
    code: string;
    value: string;
}

const MedicalSpecialty: FunctionComponent<MedicalSpecialtyProps> = ({ code, value }) => {
    const { allMedicalSpecialties } = useAppStore();

    if (!allMedicalSpecialties[code]) {
        return <>Không rõ</>;
    }

    if (!allMedicalSpecialties[code][value]) {
        return <>{code}</>;
    }

    return <>{allMedicalSpecialties[code][value]}</>;
};

export default MedicalSpecialty;

export const useMedicalSpecialites = () => {
    const { allMedicalSpecialties } = useAppStore();

    return {
        parse(data: string | string[], keyBy?: any) {
            const getBy = (medicalSpecialty, keyBy?: any) => {
                if (medicalSpecialty) {
                    if (keyBy) {
                        return medicalSpecialty[keyBy];
                    }
                    return medicalSpecialty;
                }

                return null;
            };

            if (Array.isArray(data)) {
                return data.map((code: string) => {
                    const medicalSpecialty = allMedicalSpecialties[code];
                    return getBy(medicalSpecialty, keyBy);
                });
            }

            const medicalSpecialty = allMedicalSpecialties[data.toString()];
            return getBy(medicalSpecialty, keyBy);
        },
    };
};
